import type { LinearProgressProps } from '@mui/material';
import { Box, LinearProgress, Typography } from '@mui/material';
import React from 'react';

export default function Progress(
  props: LinearProgressProps & { value: number; width?: number | string }
) {
  const { value, width } = props;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography color="text.secondary" variant="body2">{`${Math.round(
          value
        )}%`}</Typography>
      </Box>
    </Box>
  );
}
